import { openSidebar } from "../components/Tasks/tasks.service";
import { icon, label, number } from "../config";
import { hasHtmlAnchorHref } from "../config/regex";
import store from "../store";
import { commentDateAndTimeFormat, getHighlightedText, sanitizeHtmlString } from "./common";

const handleSidebarClick = async (TaskId) => {
  const state = store.getState();
  await openSidebar({ id: TaskId, userId: state.auth.user.id, taskHistoryId: null });
};

/**
 * Renders a single activity log item (description, timestamp).
 * If description contains an HTML anchor tag, renders it as sanitized HTML so links are clickable;
 * otherwise highlights task code if present, or renders plain text.
 * @param {Object} props - Activity log item
 * @param {string} [props.Description] - Activity log description (may contain HTML)
 * @param {string} [props.TaskCode] - Task code to highlight in description
 * @param {string} [props.CreatedOn] - Created timestamp
 * @param {string|number} [props.Id] - Item id
 * @returns {JSX.Element}
 */
const getActivityItems = (props) => {
  const description = props?.Description ?? "";
  let content;

  if (hasHtmlAnchorHref.test(description)) {
    content = (
      <div className='activity-log-description-cell' dangerouslySetInnerHTML={{ __html: sanitizeHtmlString(description) }} />
    );
  } else if (props?.Description?.includes(props?.TaskCode)) {
    content = <div>{getHighlightedText(props?.Description, props?.TaskCode)}</div>;
  } else {
    content = <div>{props?.Description}</div>;
  }

  return (
    <div key={props?.Id} className='log-item position-relative'>
      <span>{icon.DATE_RANGE}</span>
      {content}
      <p className='small text-muted log-date-time'>{" at " + commentDateAndTimeFormat(props?.CreatedOn)}</p>
    </div>
  );
};

/**
 * renders  activity logs items.
 * @param {activityLogData}
 * @returns {JSX}
 */
export const renderActivityLog = (activityLogData, isTeamActivityLog = false) => {
  return (
    <div>
      {Object.entries(activityLogData).map(([key, value], index) => (
        <div>
          <div key={key} className='activity-log-wrapper position-relative'>
            <p className='activity-date-range d-inline-block'>{key}</p>
            <ul className='activity-log-item'>{value?.map((item) => getActivityItems(item))}</ul>
          </div>
        </div>
      ))}
    </div>
  );
};
